<template>
  <div class="container">

    <div class="content">
      <div class="item">
        <div class="content">
          <div class="title">
            账号
          </div>
          <div class="phone">{{ phone }}</div>
        </div>

        <div class="line"></div>
      </div>
      <div class="item">
        <div class="content">
          <div class="title">
            验证码
          </div>
          <van-field
              v-model="smsCode"
              placeholder="请输入验证码"
          />
        </div>

        <div v-if="time === 60" @click="getLogoutCode" class="btn">
          获取验证码
        </div>
        <div v-else class="btn-g">
          {{ time }}s
        </div>

        <div class="line"></div>
      </div>
    </div>

    <div class="bottom">
      <div v-if="smsCode.length > 0" @click="toNext" class="btn">下一步</div>
      <div v-else class="btn-g">下一步</div>
    </div>
  </div>
</template>

<script>
import api from "@/api/privacy";
import {Field, Toast} from "vant";
import {sendSMS} from "../../util/jsbridge";

export default {
  name: "AuthCenter",
  components: {
    [Field.name]: Field,
  },
  data() {
    return {
      phone: '',
      smsCode: '',
      time: 60,
    };
  },
  mounted() {
    this.phone = this.$route.query.phone
    window.scroll(0,0)
  },
  methods: {
    getLogoutCode() {
      sendSMS()
      this.setTime()
    },
    setTime() {
      this.time = this.time - 1
      var timer = setInterval(() => {
        this.time = this.time - 1
        if (this.time === 0) {
          clearInterval(timer)
          this.time = 60
        }
      }, 1000)
    },
    toNext() {
      api.verLogoutCode({smsCode: this.smsCode}).then(response => {
        if (response.result === 0) {
          this.$router.push({
            path: "/cancelContent",
            query: {code: response.data.code}
          });
        } else {
          Toast(response.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.container {
  background-color: white;
  min-height: 100vh;
  position: relative;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 5.3vw 0 5.3vw;

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-top: 8vw;

    .content {
      display: flex;
      flex-direction: column;
      margin: 0 0 2.7vw 0;

      .title {
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
        margin-bottom: 8vw;
      }

      .phone {
        font-size: 14px;
        color: #999999;
        line-height: 14px;
      }
    }

    .line {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 0.3vw;
      background-color: #EAEAEA;
    }

    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 26.7vw;
      height: 10.7vw;
      background-color: #286EFF;
      border-radius: 5.3vw;
      font-size: 14px;
      color: white;
      line-height: 14px;
    }

    .btn-g {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 26.7vw;
      height: 10.7vw;
      background-color: #DADADA;
      border-radius: 5.3vw;
      font-size: 14px;
      color: white;
      line-height: 14px;
    }
  }
}

.bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54.7vw;
    height: 12vw;
    background-color: #286EFF;
    color: white;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    border-radius: 6.1vw;
    margin-bottom: 8vw;
  }

  .btn-g {
    background-color: #DADADA;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54.7vw;
    height: 12vw;
    color: white;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    border-radius: 6.1vw;
    margin-bottom: 8vw;
  }
}
</style>
